import { FC, useMemo } from "react";

import { unique } from "@ryde/shared";

import { ErrorsDisplayItem } from "./errors-display.item";

interface IErrorsDisplayServerContainer {
  serverErrors: string[] | undefined;
}

export const ErrorsDisplayServerContainer: FC<
  IErrorsDisplayServerContainer
> = ({ serverErrors }) => {
  const serverErrorsNormalized = useMemo(() => {
    return serverErrors?.length ? unique(serverErrors) : [];
  }, [serverErrors]);

  return serverErrorsNormalized?.map((error, i) => (
    <ErrorsDisplayItem key={`${error}_${i}`} errorDescription={error} />
  ));
};
